module.exports = __webpack_public_path__ + "static/media/sql.7669764a.svg";